angular.module('app').config(banksRouting);

function banksRouting($routeProvider) {
  $routeProvider.when('/banks', {
    pageTitle: 'BANKS',
    template: '<banks-page></banks-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
      // ajs: true,
    },
    accessPermission: 'index_bank_accountadmin',
    authReq: true,
  });
}

banksRouting.$inject = ['$routeProvider'];
